// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
"use strict";
import Vue from "vue";
import iView from "iview";
import iviewArea from "iview-area";
import App from "./App";
import { router } from "./router/index";
import store from "./store";
import "@/locale";
import "iview/dist/styles/iview.css";
import VueI18n from "vue-i18n";
import oss from "ali-oss";

import { uploadSign } from "@/api/index.js";
import Icon from "vue-awesome/components/Icon";
// 按需引入awesome图标
import element from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "vue-awesome/icons/brands/qq";
import "vue-awesome/icons/brands/weixin";
import "vue-awesome/icons/brands/weibo";
import "vue-awesome/icons/brands/github";
import {
  getRequest,
  postRequest,
  putRequest,
  deleteRequest,
  uploadFileRequest,
} from "@/libs/axios";
import { setStore, getStore, removeStore } from "@/libs/storage";
import util from "@/libs/util";
import hasPermission from "@/libs/hasPermission";
import hasRole from "@/libs/hasRole";
import VueStomp from "vue-stomp";
import VueVirtualScroller from "vue-virtual-scroller";
import VueLazyload from "vue-lazyload";
import "@babel/polyfill";
import "./index.less";

Buffer.prototype.slice = function(start, end) {
  var len = this.length;
  start = ~~start;
  end = end === undefined ? len : ~~end;

  if (start < 0) {
    start += len;
    if (start < 0) start = 0;
  } else if (start > len) {
    start = len;
  }

  if (end < 0) {
    end += len;
    if (end < 0) end = 0;
  } else if (end > len) {
    end = len;
  }

  if (end < start) end = start;

  var newBuf = this.subarray(start, end);
  // Return an augmented `Uint8Array` instance
  newBuf.__proto__ = Buffer.prototype;
  return newBuf;
};
Vue.filter("moneyFilter", function(value) {
  let back = "",
    nowValue = parseInt(value),
    pointNum = value.toString().split(".")[1];
  while (nowValue / 1000 > 1) {
    back =
      "," +
      (nowValue % 1000 > 99
        ? nowValue % 1000
        : nowValue % 1000 > 9
        ? "0" + (nowValue % 1000)
        : "00" + (nowValue % 1000)) +
      back;
    nowValue = parseInt(nowValue / 1000);
  }
  back = "," + (nowValue % 1000) + back;
  back = back.slice(1);
  return back + (pointNum ? "." + pointNum : "");
});
Vue.config.productionTip = false;
Vue.use(VueLazyload, {
  error: require("./assets/img-error.png"),
  loading: require("./assets/loading2.gif"),
});
Vue.use(VueI18n);
Vue.use(iView);
uploadSign().then(
  (data) => {
    data.secure = true;
    let OSS = new oss(data);
    Vue.prototype.$oss = OSS;
  },
  (err) => console.log(err)
);
Vue.use(iviewArea);
Vue.component("icon", Icon);
Vue.use(VueStomp);
Vue.use(VueVirtualScroller);
Vue.use(hasPermission);
Vue.use(hasRole);
Vue.use(element);
// 挂载全局使用的方法
Vue.prototype.getRequest = getRequest;
Vue.prototype.postRequest = postRequest;
Vue.prototype.putRequest = putRequest;
Vue.prototype.deleteRequest = deleteRequest;
Vue.prototype.uploadFileRequest = uploadFileRequest;
Vue.prototype.setStore = setStore;
Vue.prototype.getStore = getStore;
Vue.prototype.removeStore = removeStore;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  render: (h) => h(App),
  data: {
    currentPageName: "",
  },
  mounted() {
    // 初始化菜单
    util.initRouter(this);
    this.currentPageName = this.$route.name;
    // 显示打开的页面的列表
    this.$store.commit("setOpenedList");
    this.$store.commit("initCachepage");
  },
});
